import cn from 'classnames'
import Image from 'next/image'
import {FC, ReactNode} from 'react'

import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {CardWrapper} from '../common/cards/CardWrapper'
import {Button} from '../common/content/Button'
import {Text, TextFontWeight, TextVariant} from '../common/content/Text'

export type ServiceRequestSolutionCardType = {
  title: string
  description: string | ReactNode
  imageSrc: string
  imageAlt: string
  linkHref?: string
  linkText?: string
  isImageFullHeight?: boolean
}

export const ServiceRequestSolutionCard: FC<ServiceRequestSolutionCardType> = ({
  title,
  description,
  imageSrc,
  imageAlt,
  linkHref,
  linkText,
  isImageFullHeight = true,
}) => (
  <>
    <CardWrapper isHoverable={false}>
      <div className="card">
        <div>
          <Text variant={TextVariant.h4} element="h3" align="center">
            {title}
          </Text>
          <div className="description">
            <Text align="center">{description}</Text>
          </div>
          {linkHref && linkText && (
            <div className="button-wrapper">
              <Link href={linkHref}>
                <Button type="button" fontWeight={TextFontWeight.medium}>
                  {linkText}
                </Button>
              </Link>
            </div>
          )}
        </div>
        <div className={cn('image', isImageFullHeight && 'full-height')}>
          <Image
            src={imageSrc}
            alt={imageAlt}
            width={350}
            height={220}
            style={{display: 'block', width: '100%', height: '100%', objectFit: 'contain'}}
          />
        </div>
      </div>
    </CardWrapper>

    <style jsx>{`
      .card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding: ${theme.spacing[5]} ${theme.spacing[4]};
        border-radius: 12px;
        background-color: ${theme.palette.background.butter};
      }
      .description {
        margin-top: ${theme.spacing[2]};
      }
      .image {
        height: 120px;
        margin-top: ${theme.spacing[5]};
      }
      .button-wrapper {
        text-align: center;
        margin-top: ${theme.spacing[3]};
      }
      .full-height {
        height: 224px;
        border-radius: 12px;
        overflow: hidden;
        margin: ${theme.spacing[5]} -${theme.spacing[5]} -${theme.spacing[5]};
      }
      @media ${TABLET_SCREENSIZE} {
        .full-height {
          height: auto;
        }
      }
      @media ${MOBILE_SCREENSIZE} {
        .card {
          padding: ${theme.spacing[4]};
        }
        .image:not(.full-height) {
          height: 80px;
        }
        .full-height {
          margin: ${theme.spacing[4]} -${theme.spacing[4]} -${theme.spacing[4]};
        }
      }
    `}</style>
  </>
)
